import { ComingSoonPanel, IconAddon } from '@shared/ui';

/**
 * The top layer, and the tab that inherits the Add-ons promise.
 *
 * `Add-ons` used to be its own nav entry, describing "commercial modules a
 * client can purchase. Each add-on bundles feature flags and entitlement
 * limits". That is this tab, renamed: the nav cannot carry both words without
 * someone asking how they differ, so `/addons` redirects here.
 *
 * The description changed with the name. The old one was two levels — an add-on
 * bundling flags — and the model has three, with components in between.
 */
export function CatalogProductsTab() {
    return (
        <ComingSoonPanel
            icon={<IconAddon className="size-6" />}
            title="Products"
            blurb="Commercial modules a museum can buy, each one a bundle of components. The catalog, its per-tenant activations, and what they cost land here."
        />
    );
}
